import { render, staticRenderFns } from "./dias-laborales.vue?vue&type=template&id=488cc87e&scoped=true&"
import script from "./dias-laborales.vue?vue&type=script&lang=js&"
export * from "./dias-laborales.vue?vue&type=script&lang=js&"
import style0 from "./dias-laborales.vue?vue&type=style&index=0&id=488cc87e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488cc87e",
  null
  
)

export default component.exports